import { tokens } from "@manifesthhqinc/ui-library";
import styled from "styled-components";

export const HeadlineMedium = styled.h2<{ $textAlign?: "center" | "left" | "right" }>`
  font-size: 24px;
  line-height: 36px;
  font-weight: ${tokens.font.weight.headline.medium};
  text-align: ${(props) => props.$textAlign || "left"};
`;

export const BodyLargeRegular = styled.p<{
  $textAlign?: "center" | "left" | "right";
  $maxWidth?: string;
  $color?: string;
}>`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${tokens.font.weight.body.large.regular};
  text-align: ${(props) => props.$textAlign || "left"};
  ${(props) =>
    props.$maxWidth &&
    `max-width: ${props.$maxWidth};
  margin-left:auto;
  margin-right: auto;`}
  color: ${(props) => (props.$color ? props.$color : "inherit")};

  ${(props) => props.$textAlign === "left" && `align-self:flex-start;`}
`;

export const TitleLarge = styled.h3<{ $textAlign?: "center" | "left" | "right" }>`
  font-size: 20px;
  line-height: 30px;
  font-weight: ${tokens.font.weight.title.large};
  text-align: ${(props) => props.$textAlign || "left"};
  ${(props) => props.$textAlign === "left" && `align-self: flex-start;`}
`;

export const Highlight = styled.span`
  font-size: inherit;
  font-weight: inherit;
  color: ${tokens.color.text.highlight};
`;

export const BodyMediumRegular = styled.p<{ $color?: string; $textAlign?: "left" | "center" }>`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${(props) => (props.$color ? props.$color : "inherit")};
  text-align: ${(props) => props.$textAlign || "left"};
`;

export const BodyMediumBold = styled(BodyMediumRegular)`
  font-weight: 500;
`;

export const TitleMedium = styled.p<{ $textAlign?: "center" | "left"; $color?: string }>`
  font-size: 18px;
  line-height: 24px;
  font-style: normal;
  font-weight: 500;
  text-align: ${(props) => props.$textAlign || "left"};
  color: ${(props) => props.$color || "inherit"};
`;

export const BodyLargeBold = styled.p<{ $color?: string; $textAlign?: "left" | "center" | "right" }>`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: ${(props) => (props.$color ? props.$color : "inherit")};
  text-align: ${(props) => props.$textAlign || "left"};
`;

export const LabelLarge = styled.span<{ $color?: string }>`
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  color: ${(props) => (props.$color ? props.$color : "inherit")};
`;

export const LabelMedium = styled.span<{
  $underline?: boolean;
}>`
  font-size: 12px;
  line-height: 16px;
  ${(props) => props.$underline && `text-decoration:underline;`}
`;

export const ErrorText = styled(BodyMediumRegular)<{ $marginBottom?: number }>`
  color: ${tokens.color.text.error};
  margin-bottom: ${(props) => `${props.$marginBottom || -16}-px`};
  text-align: left;
  align-self: flex-start;
`;

export const ButtonText = styled.button`
  font-size: inherit;
  font-weight: inherit;
  color: ${tokens.color.text.button.link.default};
  text-decoration: underline;
  cursor: pointer;
`;
